module.exports = __webpack_public_path__ + "img/anning02.b5e27dfd.png";